module.exports = __webpack_public_path__ + "static/rainforest-min-4518f4bae734ea1b6cf4811eed09df6b.jpg";